<section
	[editableInStoryblok]="_editable()"
	class="section-gap-wide section-spacing px-0 pb-0"
	data-test-class="storytelling-section"
>
	<div class="px-3 lg:p-0">
		<sb-columns [colOne]="titleWithFigures" component="columnOne" />
	</div>
	<div class="flex flex-col items-center">
		@if (storytellings().length > 0) {
			<div
				[class]="
					cn(
						'section-gap-wide flex w-full flex-col items-center pb-(--vp-section-gap-y)',
						!hideBackground() && 'bg-section-diamond-pattern'
					)
				"
				data-test-class="storytelling-backdrop"
			>
				@for (
					storytelling of storytellings();
					track $index;
					let index = $index,
						odd = $odd
				) {
					<ng-container
						[ngTemplateOutlet]="storytellingRef"
						[ngTemplateOutletContext]="{
							extraImage: vpExtraImages[index],
							image: vpImages[index],
							isFullscreen: false,
							storytelling: storytelling,
							position: odd ? 'right' : 'left',
						}"
					/>
				}
			</div>
		}
		@if (storytellingFullscreen()?.length > 0) {
			<div
				[class]="
					cn(
						'w-full max-lg:pb-(--vp-section-spacing-y)',
						!hideBackground() && 'max-lg:bg-section-diamond-pattern'
					)
				"
				data-test-class="storytelling-fullscreen-backdrop"
			>
				@for (
					storytelling of storytellingFullscreen();
					track $index;
					let index = $index
				) {
					<ng-container
						[ngTemplateOutlet]="storytellingRef"
						[ngTemplateOutletContext]="{
							image: vpImagesFullscreen[index],
							isFullscreen: true,
							storytelling: storytelling,
							position:
								storytellings().length % 2 !== 0
									? 'right'
									: 'left',
						}"
					/>
				}
			</div>
		}
	</div>
</section>

<ng-template
	#storytellingRef
	let-extraImage="extraImage"
	let-image="image"
	let-isFullscreen="isFullscreen"
	let-position="position"
	let-storytelling="storytelling"
>
	<vp-storytelling
		[editableInStoryblok]="storytelling._editable"
		[extraImage]="extraImage"
		[image]="image"
		[isFullscreen]="isFullscreen"
		[position]="position"
		[video]="storytelling.video?.[0]"
		class="w-full"
	>
		<header>
			<h3 class="heading-group">
				{{ storytelling.title }}
			</h3>
			<p class="heading-group-overline" role="doc-subtitle">
				{{ storytelling.overline }}
			</p>
		</header>
		@for (blok of storytelling.content; track $index) {
			@if (components) {
				<ndc-dynamic
					[ndcDynamicComponent]="components[blok['component']]"
					[ndcDynamicInputs]="blok"
					class="hidden"
				/>
			}
		}
	</vp-storytelling>
</ng-template>
